import moment from "moment";
import { KeyValuePair } from "@shoothill/core";
import { WeeklyRotaViewModel } from "../WeeklyRotaViewModel";

export class DomainManager {
    constructor(private viewModel: WeeklyRotaViewModel) {}

    public get formattedDateRange(): string {
        return moment(this.viewModel.getValue("startDate")).format("YYYY-MM-DD");
    }

    public get copyWeeklyDataOptions(): KeyValuePair[] {
        return [
            { key: true, text: "Yes" },
            { key: false, text: "No" },
        ];
    }

    public get addWeeklyRotaButtonDisplayName(): string {
        return this.viewModel.managers.ui.isProcessing ? "Adding" : "Add";
    }
}
